






import { Component, Mixins, Prop, Provide, Watch } from 'vue-property-decorator';
import MixinChartRaw from '../../../plugins/podolib/services/helper/mixins/chart/raw';
import { DrawAnglesFeetSVG } from '@/plugins/podolib/services/charts/prosup-feet/angles-prosup-walking-feet';

@Component
export default class ChartRawPronationSupinationFeet extends Mixins(MixinChartRaw) {
  @Prop({ default: 400 }) width!: number;
  @Prop({ default: 'heelStrike' }) angleType!: string;

  @Provide() graphCanvas: DrawAnglesFeetSVG | null = null;

  get heelStrike() {
    return {
      id: 'heelStrike',
      left: this.values.computed_data.left.aggregates.pronation_angle_foot_in.avg,
      right: this.values.computed_data.right.aggregates.pronation_angle_foot_in.avg,
    };
  }
  get toesStrike() {
    return {
      id: 'toesStrike',
      left: this.values.computed_data.left.aggregates.pronation_angle_FFI.avg,
      right: this.values.computed_data.right.aggregates.pronation_angle_FFI.avg,
    };
  }
  get heelOff() {
    return {
      id: 'heelOff',
      left: this.values.computed_data.left.aggregates.pronation_angle_FFO.avg,
      right: this.values.computed_data.right.aggregates.pronation_angle_FFO.avg,
    };
  }
  get toesOff() {
    return {
      id: 'toesOff',
      left: this.values.computed_data.left.aggregates.pronation_angle_foot_out.avg,
      right: this.values.computed_data.right.aggregates.pronation_angle_foot_out.avg,
    };
  }

  @Watch('values', { deep: true })
  onValuesChange() {
    this.draw();
  }

  draw() {
    this.graphCanvas = new DrawAnglesFeetSVG(
      this.$refs['canvas'] as HTMLCanvasElement,
      this.angleType,
      (this as any)[this.angleType].left,
      (this as any)[this.angleType].right,
    );
    requestAnimationFrame(() => {
      this.graphCanvas!.draw();
    });
  }

  mounted() {
    this.draw();
  }
}
